import { render } from "./template.vue?vue&type=template&id=61655088&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=61655088&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61655088"]])

export default __exports__